import React from 'react';
import { ChevronRight } from 'lucide-react';

/**
 * PageHeader - Premium page header with title, subtitle, breadcrumbs, and action buttons
 * TradebotX-inspired: large title, muted subtitle, breadcrumb trail
 */
export default function PageHeader({
  title,
  subtitle,
  breadcrumbs = [],
  actions,
  className = '',
}) {
  return (
    <div className={`mb-8 animate-fade-in ${className}`}>
      {breadcrumbs.length > 0 && (
        <div className="flex items-center gap-1.5 mb-3">
          {breadcrumbs.map((crumb, i) => (
            <React.Fragment key={i}>
              {i > 0 && (
                <ChevronRight size={12} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
              )}
              <span
                style={{
                  color: i === breadcrumbs.length - 1 ? 'var(--accent-primary)' : 'var(--text-muted)',
                  fontWeight: i === breadcrumbs.length - 1 ? 600 : 400,
                  fontSize: '0.7rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                }}
              >
                {crumb}
              </span>
            </React.Fragment>
          ))}
        </div>
      )}
      <div className="flex items-start justify-between flex-wrap gap-4">
        <div>
          <h1
            style={{
              fontWeight: 800,
              color: 'var(--text-primary)',
              fontSize: '1.875rem',
              letterSpacing: '-0.025em',
              lineHeight: 1.2,
              margin: 0,
            }}
          >
            {title}
          </h1>
          {subtitle && (
            <p
              style={{
                color: 'var(--text-secondary)',
                marginTop: 6,
                fontSize: '0.9rem',
                margin: '6px 0 0',
                lineHeight: 1.5,
              }}
            >
              {subtitle}
            </p>
          )}
        </div>
        {actions && <div className="flex items-center gap-3 flex-shrink-0">{actions}</div>}
      </div>
    </div>
  );
}
